// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"27b1c90b909a12eb","703":"e184cd320bf02d4f","787":"c77ceaf74268d277"}[chunkId] + ".chunk.js";
};